// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: var(--app-ink-alpha-250);
  /* Acima dos overlays Material (1000) e Bootstrap (1050). */
  z-index: 1100;
}

.load-speeding-wheel {
  width: 80px;
  height: 80px;
  border: 5px solid var(--app-solicitacao-red);
  border-radius: 50%;
  border-left-color: transparent;
  border-right-color: transparent;
  animation: load-spin 500ms infinite linear;
  -o-animation: load-spin 500ms infinite linear;
  -ms-animation: load-spin 500ms infinite linear;
  -webkit-animation: load-spin 500ms infinite linear;
  -moz-animation: load-spin 500ms infinite linear;
}

@keyframes load-spin {
  100% {
    transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/spinner/spinner.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,0CAA0C;EAC1C,2DAA2D;EAC3D,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,0CAA0C;EAC1C,6CAA6C;EAC7C,8CAA8C;EAC9C,kDAAkD;EAClD,+CAA+C;AACjD;;AAEA;EACE;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;AACF","sourcesContent":[".spinner-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  width: 100%;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: var(--app-ink-alpha-250);\n  /* Acima dos overlays Material (1000) e Bootstrap (1050). */\n  z-index: 1100;\n}\n\n.load-speeding-wheel {\n  width: 80px;\n  height: 80px;\n  border: 5px solid var(--app-solicitacao-red);\n  border-radius: 50%;\n  border-left-color: transparent;\n  border-right-color: transparent;\n  animation: load-spin 500ms infinite linear;\n  -o-animation: load-spin 500ms infinite linear;\n  -ms-animation: load-spin 500ms infinite linear;\n  -webkit-animation: load-spin 500ms infinite linear;\n  -moz-animation: load-spin 500ms infinite linear;\n}\n\n@keyframes load-spin {\n  100% {\n    transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@-o-keyframes load-spin {\n  100% {\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@-ms-keyframes load-spin {\n  100% {\n    -ms-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes load-spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@-moz-keyframes load-spin {\n  100% {\n    -moz-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
